export default __webpack_public_path__ + "static/media/Windy_03.491cc477.png";